import React, { useEffect, useState } from "react";
import { withTitle, withAuth } from "../../HoC";

import style, {
  wrapper,
  section1,
  section2,
  section3,
  info,
  online,
  overlay,
  logowrapper,
} from "./device.module.scss";

import { QRCodeComponent } from "../../Components/QRCode";
import { registrationURL } from "../../utils/constants";
import { Door } from "../../Components/Door/Door";
import { Queue } from "../../Components/Qeue/Queue";
import { socketManager } from "../../services/socketService/socketManager";
import { compose } from "redux";
import { connect } from "react-redux";
import { generateUniqueId } from "../../utils/uuid4";
import { withMessageOverlay } from "../../HoC/withTimeoutOverlay";
import { postRequest } from "../../services/Requests";
import { Confirmation } from "../../Components/Confirmed/Confirmation";

import { Footer } from "../../Components/Footer/Footer";
import { MessageOverlay } from "../../Components/MessageOverlay/MessageOverlay";
import { Header } from "../../Components/Header/Header";
import { translate } from "../../translations/translate";
import { Button } from "../../Components/button";
import { Link } from "react-router-dom";

export const DevicePage = (props) => {

  const {
    devices = [],
    socketReducer,
    match,
  } = props;

  const {
    stage = 0,
    timer,
    queue = [],
    isConnected,
    maxReached = false,
  } = socketReducer;

  const {
    id: deviceId,
    uuid,
  } = devices.find((e) => e.uuid === match.params.deviceId) || {};

  if (!deviceId) {
    props.history.push("/admin");
  }

  const [ result, setResult ] = useState<{ isOpen: boolean, loading: boolean, data: any }>({ isOpen: false, loading: false, data: {} });

  const registerBooking = () => {
    setResult({ isOpen: true, loading: true, data: {} });
    postRequest({
      url: `register/${uuid}`,
      body: {
        email: "",
        bookSource: 0,
      },
    }).then(({ data }: any) => {
      setResult({ isOpen: true, loading: false, data });
      setTimeout(() => {
        setResult({ isOpen: false, loading: false, data: {}});
      }, 4000);
    }).catch((er) => {
      // console.log(er);
    });
  };

  useEffect(() => {
    const randomId = generateUniqueId();
    socketManager.init({ deviceId, uid: randomId });
    return () => socketManager.close();
  }, []);

  return (<div className={wrapper}>
    <Header withCode />
    <main>
      <section style={{ background: !stage ? "var(--color-danger)" : "var(--color-success)", transition: "all .5s ease-in-out" }} className={section1}>
        <Door isOpen={stage === 1}/>
      </section>
      <section className={section2} >
        <h3> {translate("scan-code-text")} </h3>
        <QRCodeComponent onClick={registerBooking} text={`${registrationURL}${uuid}`} />
      </section>
      <section className={section3}>
        <Queue stage={stage} data={queue}/>
      </section>
    </main>
    <Footer isConnected={isConnected} />
    {maxReached ?
      (<MessageOverlay
        withStopSight={true}
        title={translate("max-capacity")}
        message={translate("max-capacity-description")}
      />) : null}
    {result.isOpen ? <div className={overlay}>
      <Confirmation
        loading={result.loading}
        orderNumber={result.data.orderNumber}
        startDate={result.data.startDate}
      />
    </div> : null}
  </div>);
};

const mapStateToProps = (state: any) => ({
  deviceReducer: state.deviceReducer,
  socketReducer: state.socketReducer,
  devices: state.adminReducer.devices,
});

export default compose(
  withTitle(translate("gate")),
  withAuth(0),
  connect(mapStateToProps),
  withMessageOverlay(
    translate("out-of-service"),
    translate("out-of-service-temp"),
  ),
)(DevicePage);
